// extracted by mini-css-extract-plugin
export var stepActive = "_35-3";
export var stepCompleted = "_35-4";
export var stepConnectorLine = "_35-b";
export var stepIndicatorCircle = "_35-6";
export var stepIndicatorCircleCompleted = "_35-7";
export var stepIndicatorCircleDefault = "_35-8";
export var stepIndicatorTextCompleted = "_35-9";
export var stepIndicatorTextDefault = "_35-a";
export var stepPending = "_35-5";
export var wizardContainer = "_35-1";
export var wizardContent = "_35-2";
export var wizardModal = "_35-0";